import React from "react";
import CustomContainer from "../Components/CustomContainer";
import Loader from "../Components/Loader";
import {generatePath, useParams} from "react-router-dom";
import TranslationAction from "../../Actions/TranslationAction";
import UserAction from "../../Actions/UserAction";
import {Breadcrumb, Button} from "react-bootstrap";
import CustomTranslation from "../Components/CustomTranslation";
import CustomInput from "../Components/CustomInput";
import CustomCheckBoxList from "../Components/CustomCheckBoxList";
import ConstructionSiteAction from "../../Actions/ConstructionSiteAction";

class EmailAccessibilityScreen extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        //set state
        this.state = {
            email: [],
            cs: null,
        };
    }

    componentDidMount = () => {
        this.updateElements();
    }

    updateElements = async () => {
        //get contruction site
        let cs = await ConstructionSiteAction.getConstructionSite(this.props.params.id);

        /** USERS **/

        //get users
        let users = await UserAction.getUserListConstructionSite(cs.id);

        //create options
        let userOptions = [];

        //loop users
        users.forEach(element => {
            if (element.firstName && element.lastName) {
                userOptions.push({
                    label: (element.firstName ? element.firstName : '') + (element.lastName ? ' ' + element.lastName : ''),
                    value: element.email
                });
            } else {
                userOptions.push({
                    label: (element.email ? element.email : ''),
                    value: element.email
                });
            }
        });

        /** TITLE **/

        //translate title
        let title = null;
        if (!this.state.title) {
            title = await TranslationAction.translate('KEY.Project Accessibility');
            title += ': ' + cs.name;
        } else {
            title = this.state.title;
        }

        //set state
        this.setState({
            data: {
                constructionSite: cs,
            },
            userOptions: userOptions,
            title: title,
            cs: cs.id,
        });
    }

    render = () => {
        if (this.state.data) {
            return (
                <CustomContainer
                    footer={
                        <Button
                            block
                            variant={'dark'}
                            disabled={
                                !(this.state.message && this.state.title && (this.state.email.length > 0) && (this.state.cs))
                            }
                            onClick={async () => {
                                //send request
                                await ConstructionSiteAction.sendAccessibility(this.state);
                                //navigate
                                setTimeout(() => {
                                    window.location.href = generatePath('/construction_site/:id', {id: this.state.data.constructionSite.id});
                                }, 1000);
                            }}
                        >
                            <CustomTranslation value={'KEY.Send Accessibility'} />
                        </Button>
                    }
                >
                    <div>
                        {/* Breadcrumb */}
                        <Breadcrumb className={'vertical-margin-2'} style={{marginTop: 0}}>
                            <Breadcrumb.Item
                                href={generatePath('/')}
                            >
                                <CustomTranslation value={'KEY.Home'} />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                                href={generatePath('/construction_site/:id', {id: this.state.data.constructionSite.id})}
                            >
                                {this.state.data.constructionSite.name}
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>
                                <CustomTranslation value={'KEY.Notification Accessibility'}/>
                            </Breadcrumb.Item>
                        </Breadcrumb>

                        {/* Title */}
                        <div>
                            <h1>
                                <CustomTranslation value={'KEY.Notification Accessibility'}/>
                            </h1>
                        </div>

                        {/* Form */}
                        <div>
                            <div className={'vertical-padding-3'}>
                                <CustomInput
                                    label={<CustomTranslation value={'KEY.Title'} />}
                                    iconName={'las la-quote-left'}
                                    value={this.state.title}
                                    onChangeText={(value) => {this.state({title: value})}}
                                />
                            </div>
                            <div className={'vertical-padding-3'}>
                                <CustomCheckBoxList
                                    label={<CustomTranslation value={'KEY.Recipients'} />}
                                    iconName={'las la-user'}
                                    items={this.state.userOptions}
                                    onValueChange={(values) => {this.setState({email: values})}}
                                />
                            </div>
                            <div>
                                <CustomInput
                                    label={<CustomTranslation value={'KEY.Message'} />}
                                    iconName={'las la-comment'}
                                    inputProps={{
                                        as: 'textarea',
                                        rows: 10
                                    }}
                                    onChangeText={(value) => {this.setState({message: value})}}
                                />
                            </div>
                        </div>
                    </div>
                </CustomContainer>
            );
        } else {
            return (
                <CustomContainer>
                    <Loader />
                </CustomContainer>
            );
        }
    }
}

//export
export default function (props) {
    const params = useParams();
    return <EmailAccessibilityScreen {...props} params={params} />;
}